import React, { Dispatch, SetStateAction } from 'react'
import { TextArea } from '../../common/TextArea';
import Modal2, { Modal2Footer, Modal2Button } from '../../common/Modal2';

export interface RejectionModalProps {
  rejectionReason: string;
  setRejectionReason: Dispatch<SetStateAction<string>>;
  setShowRejectModal: Dispatch<SetStateAction<boolean>>;
  setSelectedLeave: Dispatch<SetStateAction<string | null>>;
  confirmReject: () => void | Promise<void>;
  processing: string | null | boolean;
  selectedLeave: string | null;
  title?: string;
  description?: string;
  showProcessingText?: boolean;
}

const RejectionModal = ({
  rejectionReason,
  selectedLeave,
  setRejectionReason,
  setSelectedLeave,
  setShowRejectModal,
  confirmReject,
  processing,
  title = "Reject Leave Request",
  description = "Please provide a reason for rejecting this leave request.",
  showProcessingText = true,
}: RejectionModalProps) => {
  const handleClose = () => {
    setShowRejectModal(false);
    setRejectionReason("");
    setSelectedLeave(null);
  };

  return (
    <Modal2
      isOpen={true}
      onClose={handleClose}
      title={title}
      size="sm"
      closable
      maskClosable={false}
      footer={
        <Modal2Footer justify="end">
          <Modal2Button variant="secondary" onClick={handleClose}>
            Cancel
          </Modal2Button>
          <Modal2Button
            variant="danger"
            onClick={confirmReject}
            disabled={!rejectionReason.trim() || processing === selectedLeave}
            loading={(processing === selectedLeave || processing === true) && Boolean(showProcessingText)}
          >
            Confirm Reject
          </Modal2Button>
        </Modal2Footer>
      }
    >
      <p className="text-sm text-[var(--color-text-secondary)] mb-4">{description}</p>
      <TextArea
        value={rejectionReason}
        onChange={(value: string) => setRejectionReason(value)}
        placeholder="Enter rejection reason..."
      />
    </Modal2>
  );
}

export default RejectionModal
